import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import colors from 'utils/styling/colors'

/** The fixed top bar's full height. */
export const NAVIGATION_HEIGHT = '70px'

export const Navigation = styled(Flex)`
  ${({ $outlined }) =>
    $outlined &&
    css`
      outline: 1px solid ${colors('lockedWhite', 10)};
    `}
`
